import script from "./Games-airtime.vue?vue&type=script&setup=true&lang=js"
export * from "./Games-airtime.vue?vue&type=script&setup=true&lang=js"

import "./Games-airtime.vue?vue&type=style&index=0&id=d12ad28a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d12ad28a"]])

export default __exports__